"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _types = require("./types");
var _ = _interopRequireDefault(require(".."));
var _excluded = ["children"];
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var computeValue = function computeValue(value) {
  if (typeof value === "number") {
    return "".concat(value || 0, "px");
  }
  return value;
};
var ContainerDiv = (0, _styledComponents["default"])(_["default"])(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: ", ";\n    top: ", ";\n    left: ", ";\n    bottom: ", ";\n    right: ", ";\n    z-index: ", ";\n"])), function (props) {
  return (props === null || props === void 0 ? void 0 : props.position) || _types.PositionBoxTypes.RELATIVE;
}, function (props) {
  return computeValue(props === null || props === void 0 ? void 0 : props.top);
}, function (props) {
  return computeValue(props === null || props === void 0 ? void 0 : props.left);
}, function (props) {
  return computeValue(props === null || props === void 0 ? void 0 : props.bottom);
}, function (props) {
  return computeValue(props === null || props === void 0 ? void 0 : props.right);
}, function (props) {
  return props.zIndex || 1;
});
var PositionBox = function PositionBox(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(ContainerDiv, _extends({
    "data-test-class": "sui-position"
  }, props, {
    "data-sentry-element": "ContainerDiv",
    "data-sentry-component": "PositionBox",
    "data-sentry-source-file": "index.tsx"
  }), children);
};
PositionBox[_types.PositionBoxTypes.RELATIVE] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(PositionBox, _extends({
    position: _types.PositionBoxTypes.RELATIVE
  }, props));
};
PositionBox[_types.PositionBoxTypes.ABSOLUTE] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(PositionBox, _extends({
    position: _types.PositionBoxTypes.ABSOLUTE
  }, props));
};
PositionBox[_types.PositionBoxTypes.FIXED] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(PositionBox, _extends({
    position: _types.PositionBoxTypes.FIXED
  }, props));
};
PositionBox[_types.PositionBoxTypes.STICKY] = function (props) {
  return /*#__PURE__*/_react["default"].createElement(PositionBox, _extends({
    position: _types.PositionBoxTypes.STICKY
  }, props));
};
var _default = PositionBox;
exports["default"] = _default;